// frontend/src/components/auth/RequireAuth.js
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function RequireAuth({ children, allowedForNonAdmin = [] }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) return <p>로딩 중...</p>;
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // 관리자 검증
    if (user.role !== 'admin') {
        const path = location.pathname;
        if (!allowedForNonAdmin.includes(path)) {
            return <Navigate to="/unauthorized" replace />;
        }
    }
    return children;
}
